import React from 'react';

interface SearchTopBarProps {
  title: string;
  placeholder?: string;
  searchTerm: string;
  onSearchChange: (value: string) => void;
  totalCount?: number;
  actions?: React.ReactNode;
  variant?: 'default' | 'centered';
}

const SearchTopBar: React.FC<SearchTopBarProps> = ({
  title,
  placeholder = 'Search',
  searchTerm,
  onSearchChange,
  totalCount,
  actions,
  variant = 'default',
}) => {
  const renderCountBadge = () =>
    typeof totalCount === 'number' ? (
      <span className="rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-600">
        {totalCount}
      </span>
    ) : null;

  const renderSearchInput = (widthClass: string) => (
    <div className={`relative ${widthClass}`}>
      <span className="pointer-events-none absolute inset-y-0 left-3 flex items-center text-gray-400">
        <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M21 21l-4.35-4.35M17 10.5a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z"
          />
        </svg>
      </span>
      <input
        type="text"
        value={searchTerm}
        onChange={(event) => onSearchChange(event.target.value)}
        placeholder={placeholder}
        className="w-full rounded-lg border border-gray-200 bg-white py-2 pl-9 pr-3 text-sm text-gray-900 placeholder-gray-400 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/40"
      />
    </div>
  );

  if (variant === 'centered') {
    return (
      <div className="mb-4 grid grid-cols-1 gap-3 sm:grid-cols-[auto,1fr,auto] sm:items-center">
        <div className="flex items-center gap-2">
          <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
          {renderCountBadge()}
        </div>
        <div className="justify-self-center w-full sm:w-72 md:w-96">
          {renderSearchInput('w-full')}
        </div>
        <div className="justify-self-end">{actions}</div>
      </div>
    );
  }

  return (
    <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-center gap-2">
        <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
        {renderCountBadge()}
      </div>
      <div className="flex w-full flex-col gap-3 sm:w-auto sm:flex-row sm:items-center sm:gap-3">
        {renderSearchInput('w-full sm:w-72')}
        {actions && <div className="sm:self-stretch">{actions}</div>}
      </div>
    </div>
  );
};

export default SearchTopBar;

